'use strict';

var PubSubObject = function(){

    var cache = {};

    function publish(topic, args, scope) {
		if (cache[topic]) {
			var thisTopic = cache[topic],
				i = thisTopic.length - 1;

			for (i; i >= 0; i -= 1) {
				thisTopic[i].apply( scope || this, args || []);
			}
		}
	}

	function subscribe(topic, callback) {
		if (!cache[topic]) {
			cache[topic] = [];
		}
		cache[topic].push(callback);
		return [topic, callback];
	}

	function unsubscribe(handle, completly) {
		var t = handle[0],
			i = cache[t].length - 1;

		if (cache[t]) {
			for (i; i >= 0; i -= 1) {
				if (cache[t][i] === handle[1]) {
					cache[t].splice(i, 1);
					if(completly){ delete cache[t]; }
				}
			}
		}
	}

	return {
		publish: publish,
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};

}

var PubSub = new PubSubObject();
